/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserFromJSON, UserToJSON } from './User';
export function GetMeResponseDataFromJSON(json) {
    return GetMeResponseDataFromJSONTyped(json, false);
}
export function GetMeResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        user: !exists(json, 'user') ? undefined : UserFromJSON(json['user'])
    };
}
export function GetMeResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        user: UserToJSON(value.user)
    };
}
